import { Link } from "react-router-dom";
import { Mail, MapPin, Globe, ArrowUpRight } from "lucide-react";
import { NAV, CONTACT } from "@/lib/site";
import Logo from "@/components/Logo";

export default function Footer() {
  return (
    <footer className="relative mt-10 overflow-hidden border-t border-slate-900/10 bg-[#e9eef5]" data-testid="footer">
      <div className="pointer-events-none absolute -top-32 left-1/2 h-64 w-[70%] -translate-x-1/2 rounded-full bg-blue-600/10 blur-[120px]" />
      <div className="mx-auto max-w-6xl px-6 py-16">
        <div className="grid gap-12 md:grid-cols-[1.4fr_1fr_1fr]">
          <div>
            <Logo size="md" />
            <p className="mt-5 max-w-sm text-base leading-relaxed text-slate-600">
              A Dubai-based engineering studio building AI, financial and cloud
              systems with a TP99.99 reliability posture.
            </p>
          </div>

          <div>
            <h4 className="font-mono-x text-xs uppercase tracking-[0.2em] text-slate-500">Navigate</h4>
            <ul className="mt-5 space-y-3">
              {NAV.map((n) => (
                <li key={n.to}>
                  <Link
                    to={n.to}
                    className="text-slate-700 transition-colors hover:text-blue-600"
                    data-testid={`footer-link-${n.label.toLowerCase()}`}
                  >
                    {n.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-mono-x text-xs uppercase tracking-[0.2em] text-slate-500">Get in touch</h4>
            <ul className="mt-5 space-y-4 text-sm text-slate-700">
              <li className="flex items-start gap-3">
                <Mail size={16} className="mt-0.5 text-blue-600" />
                <a href={`mailto:${CONTACT.email}`} className="hover:text-blue-600">{CONTACT.email}</a>
              </li>
              <li className="flex items-start gap-3">
                <Globe size={16} className="mt-0.5 text-blue-600" />
                <span>{CONTACT.website}</span>
              </li>
              <li className="flex items-start gap-3">
                <MapPin size={16} className="mt-0.5 text-blue-600" />
                <span>{CONTACT.address}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-start justify-between gap-4 border-t border-slate-900/10 pt-6 md:flex-row md:items-center">
          <p className="text-sm text-slate-500">
            © {new Date().getFullYear()} StratFlow Tech FZCO. All rights reserved.
          </p>
          <Link
            to="/contact"
            className="group inline-flex items-center gap-1.5 text-sm font-medium text-slate-700 hover:text-blue-600"
          >
            Let&apos;s build something
            <ArrowUpRight size={15} className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </Link>
        </div>
      </div>
    </footer>
  );
}
